import { AuthContext } from '@views/contexts'
import { useContext } from 'react'

export const useAuth = () => useContext(AuthContext)
